import { action } from "../common/Action"
import { GeographicClient } from "../generated";
const Client = new GeographicClient();
class FrazioniActions {
    @action
    search(codFisComune: string) {
        return Client
            .getFrazioniByComune(codFisComune)
            .then(frazioni => ({
                codFisComune,
                frazioni
            }));
    };
}
export default new FrazioniActions();